import { z } from 'zod';

export const movimentacaoEstoqueSchema = z.object({
  id: z.string().optional(),
  produtoId: z.string().min(1, 'Produto ID é obrigatório'),
  tipo: z.enum(['entrada_compra', 'saida_venda', 'retirada_uso_proprio', 'ajuste']),
  quantidade: z.number().int().positive('Quantidade deve ser maior que zero'),
  createdAt: z.string().optional(),
  pedidoId: z.string().optional(),
  observacao: z.string().max(500).optional(),
  realizadoPor: z.string().optional(),
});

// Payload para input via API (entrada)
export const entradaEstoqueSchema = z.object({
  quantidade: z.number().int().positive('Quantidade deve ser maior que zero'),
  observacao: z.string().max(500).optional(),
  lancarDespesa: z.boolean().optional(),
  valorDespesa: z.number().positive().optional(),
});

// Payload para input via API (saida/retirada)
export const retiradaEstoqueSchema = z.object({
  quantidade: z.number().int().positive('Quantidade deve ser maior que zero'),
  observacao: z.string().max(500).optional(),
});
